angular.module('acme.view.application.pricing.lists.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.validate',
  'acme.common.service.templates',
  'acme.common.factory.notice',
  'acme.view.application.pricing.lists.createModal.controllers',
  'acme.view.application.pricing.lists.removeModal.controllers',
  'acme.view.application.pricing.lists.duplicateModal.controllers'
])

.controller('PricingListsController', ['$scope', '$state', '$uibModal', '$timeout', 'HelpersService', 'ApiService', 'CalendarService', 'TemplatesService', 'ValidateService', 'NoticeFactory', function($scope, $state, $uibModal, $timeout, HelpersService, ApiService, CalendarService, TemplatesService, ValidateService, NoticeFactory) {

  $scope.pricingLists = {

    isEditing: false,
    isRemoving: false,
    isUpdating: false,
    isLoaded: false,
    isSorting: false,

    notice: new NoticeFactory(),
    currentPriceListIndex: 0,
    currentPriceIndex: 0,
    selectedPriceListId: 0,
    currentPrice: {
      personType: {
        name: '',
        description: '',
        active: true,
        type: 'Individual',
        displayOrder: 0,
        defaultPrice: 10.50
      },
      salesChannels: [],
      price: 1.02,
      primePrice: 1.03
    },

    tmpCurrentPriceList: {},

    currentPriceList: {
      name: '',
      description: '',
      effectiveStartTime: CalendarService.toISO8601(new Date()),
      effectiveEndTime: null,
      priceListType: null,
      prices: []
    },

    salesChannels: [
      {
        "channel" : "online",
        "name" : "Online",
        "enabled" : true
      },
      {
        "channel" : "pointOfSale",
        "name" : "Point of Sale",
        "enabled" : true
      },
      {
        "channel" : "reseller",
        "name" : "Reseller",
        "enabled" : true
      },
      {
        "channel" : "customerRep",
        "name" : "Customer Rep.",
        "enabled" : true
      },
      {
        "channel" : "kiosk",
        "name" : "Kiosk",
        "enabled" : true
      }
    ],

    columns: [
      {
        field: 'orderAction',
        width: '50',
        displayName: 'Action',
        cellTemplate: '<div class="ui-grid-cell-contents text-center pricing-lists-action"><a data-ng-click="grid.appScope.moveUp(row)"><span title="Move Up" role="presentation" class="fa fa-2x fa-caret-up"></span></a><a data-ng-click="grid.appScope.moveDown(row)"><span role="presentation" title="Move Down" class="fa fa-2x fa-caret-down"></span></a></div>',
        visible: false
      },
      {
        field: 'displayOrder',
        width: '65',
        displayName: 'Listing',
        enableCellEdit: true,
        enableCellEditOnFocus: true,
        cellTemplate: '<div class="ui-grid-cell-contents text-center" ng-class="col.colIndex()">{{ COL_FIELD }}</div>',
        visible: false
      },
      {
        field: 'personType.name',
        displayName: 'Ticket Category'
      },
      {
        field: 'personType.description',
        displayName: 'Description',
        editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
        enableCellEdit: true,
        enableCellEditOnFocus: true,
        cellEditableCondition: function() {
          return $scope.pricingLists.isEditing === true;
        }
      },
      {
        field: 'price',
        displayName: 'Price',
        cellFilter: 'currency',
        editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
        enableCellEdit: true,
        enableCellEditOnFocus: true,
        cellEditableCondition: function() {
          return $scope.pricingLists.isEditing === true;
        }
      },
      {
        field: 'salesChannels[0].enabled',
        displayName: 'Web',
        cellEditableCondition: function() {
          return $scope.pricingLists.isEditing === true;
        },
        cellTemplate: '<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><input type="checkbox" class="grid-input" data-ng-if="grid.appScope.pricingLists.isEditing" data-ng-model="MODEL_COL_FIELD" /><div data-ng-if="!grid.appScope.pricingLists.isEditing"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div></div>'
      },

      {
        field: 'salesChannels[1].enabled',
        displayName: 'POS',
        cellEditableCondition: function() {
          return $scope.pricingLists.isEditing === true;
        },
        cellTemplate: '<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><input type="checkbox" class="grid-input" data-ng-if="grid.appScope.pricingLists.isEditing" data-ng-model="MODEL_COL_FIELD" /><div data-ng-if="!grid.appScope.pricingLists.isEditing"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div></div>'
      },
      {
        field: 'salesChannels[2].enabled',
        displayName: 'Reseller',
        cellEditableCondition: function() {
          return $scope.pricingLists.isEditing === true;
        },
        cellTemplate: '<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><input type="checkbox" class="grid-input" data-ng-if="grid.appScope.pricingLists.isEditing" data-ng-model="MODEL_COL_FIELD" /><div data-ng-if="!grid.appScope.pricingLists.isEditing"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div></div>'
      },
      {
        field: 'salesChannels[3].enabled',
        displayName: 'Customer Rep.',
        cellEditableCondition: function() {
          return $scope.pricingLists.isEditing === true;
        },
        cellTemplate: '<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><input type="checkbox" class="grid-input" data-ng-if="grid.appScope.pricingLists.isEditing" data-ng-model="MODEL_COL_FIELD" /><div data-ng-if="!grid.appScope.pricingLists.isEditing"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div></div>'
      },
      {
        field: 'salesChannels[4].enabled',
        displayName: 'Kiosk',
        cellEditableCondition: function() {
          return $scope.pricingLists.isEditing === true;
        },
        cellTemplate: '<div class="ui-grid-cell-contents" data-ng-class="col.colIndex()"><input type="checkbox" class="grid-input" data-ng-if="grid.appScope.pricingLists.isEditing" data-ng-model="MODEL_COL_FIELD" /><div data-ng-if="!grid.appScope.pricingLists.isEditing"><span data-ng-if="COL_FIELD">Yes</span><span data-ng-if="!COL_FIELD">No</span></div></div>'
      }

    ],

    duplicatePriceList: {},

    model: [],

    init: function() {
      $scope.$emit('Application::contentTitleChange', {
        title: 'Pricing',
        buttonRight: {
          label: 'Create Price List',
          permissions: 'PRICE_LISTS_CREATE',
          action: function() {
            $scope.pricingLists.create();
          }
        }
      });

      $scope.$on('PricingSidebarController::selectList', this.onSelectList);
      $scope.$on('PricingListsEditController::addPrice', this.onAddPrice);
      $scope.$on('uiGridEventChangeOrder', this.onGridEventChangeOrder);

      if ($state.params && $state.params.id) {
        this.selectedPriceListId = $state.params.id;
      }
      this.getPriceLists();
    },

    toggleEdit: function(restore) {
      this.isEditing = !this.isEditing;
      if (this.isEditing) {
        this.tmpCurrentPriceList = angular.copy(this.currentPriceList);
        console.log('PricingListsController::toggleEdit', this.tmpCurrentPriceList, this.currentPriceList);
        this.columns.push({
          field: 'remove',
          displayName: 'Actions',
          enableHiding: false,
          enableSorting: false,
          onCellNavClick: function(row, col) {
            $scope.pricingListsGrid.appScopeProvider.removePrice(row);
          },
          cellTemplate: '<div class="ui-grid-cell-contents" ng-class="col.colIndex()"><a data-ng-click="grid.appScope.removePrice(row)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>'
        });
      }else{
        this.notice.hideSuccessMessages();
        this.notice.hideErrorMessages();

        this.columns.pop();
        if (restore) {
          this.currentPriceList = angular.copy(this.tmpCurrentPriceList);
          console.log('PricingListsController::toggleEdit', this.tmpCurrentPriceList, this.currentPriceList);
        }
      }
    },

    toggleReorder: function(restore) {

      this.isSorting = !this.isSorting;
      this.columns[0].visible = this.isSorting;
      this.columns[1].visible = this.isSorting;
      $scope.$broadcast('DataGrid::DataChange', {type: 'COLUMN'});

      if (this.isSorting) {
        this.tmpCurrentPriceList = angular.copy(this.currentPriceList);
        console.log('PricingListsController::toggleReorder', this.tmpCurrentPriceList, this.currentPriceList);
      }else{
        this.notice.hideSuccessMessages();
        this.notice.hideErrorMessages();

        if (restore) {
          this.currentPriceList = this.tmpCurrentPriceList;
          console.log('PricingListsController::toggleReorder', this.tmpCurrentPriceList, this.currentPriceList);
        }
      }
    },

    copy: function() {

      var self = $scope.pricingLists;

      self.addModal = $uibModal.open({
        templateUrl: 'views/application/views/pricing/lists/modals/duplicatePriceList.tpl.html',
        size: 'md',
        controller: 'PriceListsDuplicateModalController',
        resolve: {
          priceLists: function() {
            return self.model;
          },
          currentPriceList: function() {
            return self.currentPriceList;
          }
        }
      });

      // Invoked when modal completes with close(params)
      self.addModal.result.then(function (name) {
        self.notice.hideSuccessMessages();
        self.notice.hideErrorMessages();

        self.duplicatePriceList = $.extend({}, self.currentPriceList);
        self.duplicatePriceList.name = name;
        ApiService.price.lists.create(self.duplicatePriceList).then(self.success.copy, self.error.copy);
      }, function () {
        // Do nothing
      });
    },

    create: function() {
      var self = $scope.pricingLists;

      self.addModal = $uibModal.open({
        templateUrl: 'views/application/views/pricing/lists/modals/createPriceList.tpl.html',
        size: 'lg',
        controller: 'PriceListsCreateModalController',
        resolve: {
          priceLists: function() {
            return self.model;
          }
        }
      });

      // Invoked when modal completes with close(params)
      self.addModal.result.then(function (priceList) {
        self.notice.hideSuccessMessages();
        self.notice.hideErrorMessages();

        ApiService.price.lists.create(priceList).then(self.success.create, self.error.create);
      }, function () {
        // Do nothing
      });
    },

    remove: function() {
      var self = $scope.pricingLists;

      self.addModal = $uibModal.open({
        templateUrl: 'views/application/views/pricing/lists/modals/removePriceList.tpl.html',
        size: 'md',
        controller: 'PriceListsRemoveModalController',
        resolve: {
          currentPriceList: function() {
            return self.currentPriceList;
          }
        }
      });

      // Invoked when modal completes with close(params)
      self.addModal.result.then(function (name) {
        self.notice.hideSuccessMessages();
        self.notice.hideErrorMessages();

        self.isRemoving = true;

        ApiService.price.lists.remove(self.currentPriceList.id).then(self.success.remove, self.success.error);
      }, function () {
        // Do nothing
      });

    },

    update: function() {
      this.notice.hideSuccessMessages();
      this.notice.hideErrorMessages();

      this.isUpdating = true;
      ApiService.price.lists.update(this.currentPriceList).then(function(response) {
        var self = $scope.pricingLists;

        self.tmpCurrentPriceList = angular.copy(self.currentPriceList);
        self.success.update(response);
      }, this.error.update);
    },

    updateClose: function() {
      this.notice.hideSuccessMessages();
      this.notice.hideErrorMessages();

      this.isUpdating = true;
      ApiService.price.lists.update(this.currentPriceList).then(function(response) {
        var self = $scope.pricingLists;

        self.tmpCurrentPriceList = angular.copy(self.currentPriceList);

        if (self.isEditing) {
          self.toggleEdit();
        }else if (self.isSorting) {
          self.toggleReorder();
        }
        self.success.update(response);
      }, this.error.update);

    },

    removePrice: function(row) {
      var self = $scope.pricingLists, i, ii, index = -1;
      console.log('PricingListsController::removePrice', row.entity);

      for (i = 0, ii = self.currentPriceList.prices.length; i < ii; i++) {
        if(self.currentPriceList.prices[i].personType.id === row.entity.personType.id) {
          index = i;
          break;
        }
      }

      if (index > -1) {
        self.currentPriceList.prices.splice(index, 1);
      }
    },

    hasPrices: function() {
      return (this.currentPriceList.prices.length > 0);
    },

    getSelectedPriceList: function() {
      var i, ii,
        r = 0;

      for (i=0,ii=this.model.length;i<ii;i++) {
        if (this.model[i].id === this.selectedPriceListId) {
          r = i;
          break;
        }
      }
      return r;
    },

    getPriceLists: function() {
      this.notice.hideSuccessMessages();
      this.notice.hideErrorMessages();

      ApiService.price.lists.list(HelpersService.getPaginator({sortField: 'name', sortDirection: 'asc'})).then(this.success.getPriceLists, this.error.getPriceLists);
    },

    getPriceList: function(id) {
      this.notice.hideSuccessMessages();
      this.notice.hideErrorMessages();
      if (id) {
        ApiService.price.lists.detail(id).then(this.success.getPriceList, this.error.getPriceList);
      }
    },

    moveUp: function(row) {
      var self = $scope.pricingLists,
          currentItem = angular.copy(row.entity),
          idx = self.currentPriceList.prices.indexOf(row.entity),
          nextItem = angular.copy(self.currentPriceList.prices[idx - 1]);
      if(idx > 0) {
        self.reorderPriceList(idx, idx - 1, currentItem, nextItem);
      }
    },

    moveDown: function(row) {
      var self = $scope.pricingLists,
          currentItem = angular.copy(row.entity),
          idx = self.currentPriceList.prices.indexOf(row.entity),
          nextItem = angular.copy(self.currentPriceList.prices[idx + 1]);
      if(nextItem) {
        self.reorderPriceList(idx, idx + 1, currentItem, nextItem);
      }
    },
    
    reorderPriceList: function (current, next, currentItem, nextItem) {
      var self = $scope.pricingLists;
      self.currentPriceList.prices[next] = currentItem;
      self.currentPriceList.prices[current] = nextItem;
      self.currentPriceList.prices.forEach(function (val, idx) { val.displayOrder = idx + 1; });
    },

    onDisplayOrderChanged: function(item, col, newValue, oldValue) {
      var i, ii,
        self = $scope.pricingLists,
        prices;

      if(newValue !== undefined && oldValue !== undefined) {
        if (newValue > self.currentPriceList.prices.length) {
          newValue = self.currentPriceList.prices.length;
        }
        prices = self.currentPriceList.prices.sort(function(a, b) {
          var r = 0;

          if (a.displayOrder < b.displayOrder) {
            r = -1;
          } else {
            r = 1;
          }
          return r;
        });
        for (i=0,ii=prices.length;i<ii;i++) {
          prices[i].displayOrder = i + 1;
        }
        self.currentPriceList.prices = prices;
      }
    },

    updateSalesChannels: function(channels) {

      var i, ii,
        j, jj,
        sc = [];

      for (i=0,ii=channels.length;i<ii;i++) {
        for (j=0,jj=this.salesChannels.length;j<jj;j++) {
          if (channels[i].channel === this.salesChannels[j].channel) {
            sc.push(angular.copy(channels[i]));
            break;
          }
        }
      }

      return sc;

    },

    process: function(lists) {
      var i, ii;

      for (i=0,ii=lists.length;i<ii;i++) {
        lists[i] = this.processList(lists[i]);
      }

      return lists;
    },

    processList: function(list) {
      var i, ii;

      for (i=0,ii=list.prices.length;i<ii;i++) {
        if (!list.prices[i].salesChannels) {
          list.prices[i].salesChannels = angular.copy(this.salesChannels);
        }else if (list.prices[i].salesChannels instanceof Array && list.prices[i].salesChannels.length !== this.salesChannels.length) {
          list.prices[i].salesChannels = this.updateSalesChannels(list.prices[i].salesChannels);
        }
        list.prices[i].salesChannels = TemplatesService.orderSalesChannels(list.prices[i].salesChannels);
      }

      return list;
    },

    success: {

      create: function(response) {
        $scope.pricingLists.model.push(response.data.payload);
        $scope.pricingLists.onSelectList({}, { id: response.data.payload.id });

        $scope.$emit('PricingListsController::priceListsUpdate', {
          selectedPriceListId: response.data.payload.id,
          model: $scope.pricingLists.model
        });

        $scope.pricingLists.notice.showSuccessMessages([{
          message: 'Successfully Created!'
        }]);

        $timeout(function() {
          $scope.pricingLists.notice.hideSuccessMessages();
        }, 3000);

      },

      copy: function(response) {
        $scope.pricingLists.model.push(response.data.payload);
        $scope.pricingLists.onSelectList({}, { id: response.data.payload.id });

        $scope.$emit('PricingListsController::priceListsUpdate', {
          selectedPriceListId: response.data.payload.id,
          model: $scope.pricingLists.model
        });

        $scope.pricingLists.notice.showSuccessMessages([{
          message: 'Successfully Duplicated!'
        }]);

        $timeout(function() {
          $scope.pricingLists.notice.hideSuccessMessages();
        }, 3000);
      },

      remove: function(response) {
        $scope.pricingLists.isRemoving = false;
        $scope.pricingLists.model.splice($scope.pricingLists.currentPriceListIndex, 1);
        $scope.pricingLists.onSelectList({}, { id: $scope.pricingLists.model[0].id });

        $scope.$emit('PricingListsController::priceListsUpdate', {
          selectedPriceListId: $scope.pricingLists.model[0].id,
          model: $scope.pricingLists.model
        });

      },

      update: function(response) {
        $scope.pricingLists.isUpdating = false;

        $scope.pricingLists.notice.showSuccessMessages([{
          message: 'Successfully Updated!'
        }]);

        $timeout(function() {
          $scope.pricingLists.notice.hideSuccessMessages();
        }, 3000);
      },

      getPriceLists: function(response) {
        $scope.pricingLists.model = $scope.pricingLists.process(response.data.payload.list);
        $scope.pricingLists.currentPriceListIndex = $scope.pricingLists.getSelectedPriceList();
        $scope.pricingLists.currentPriceList = $scope.pricingLists.model[$scope.pricingLists.currentPriceListIndex];
        $scope.pricingLists.isLoaded = true;
        if ($scope.pricingLists.currentPriceList) {
          $scope.$emit('PricingListsController::priceListsUpdate', {
            selectedPriceListId: $scope.pricingLists.currentPriceList.id,
            model: $scope.pricingLists.model
          });
        }
        $scope.$emit('AppController::endLoad');

      },

      getPriceList: function(response) {
        $scope.pricingLists.model = [$scope.pricingLists.processList(response.data.payload)];
        $scope.pricingLists.currentPriceListIndex = 0;
        $scope.pricingLists.currentPriceList = $scope.pricingLists.model[0];
        $scope.pricingLists.isLoaded = true;
        if ($scope.pricingLists.currentPriceList) {
          $scope.$emit('PricingListsController::priceListUpdate', {
            selectedPriceListId: $scope.pricingLists.currentPriceList.id,
            model: $scope.pricingLists.model
          });
        }
      }

    },

    error: {
      create: function(response) {
        $scope.pricingLists.notice.showErrorMessages([{
          message: response.data.error
        }]);
      },

      copy: function(response) {
        $scope.pricingLists.notice.showErrorMessages([{
          message: response.data.error
        }]);
      },

      remove: function(response) {
        $scope.pricingLists.notice.showErrorMessages([{
          message: response.data.error
        }]);
      },

      update: function(response) {
        $scope.pricingLists.isUpdating = false;
        $scope.pricingLists.notice.showErrorMessages([{
          message: response.data.error
        }]);
      },

      getPriceLists: function(response) {
        $scope.pricingLists.notice.showErrorMessages([{
          message: response.data.error
        }]);
      },

      getPriceList: function(response) {
        $scope.pricingLists.notice.showErrorMessages([{
          message: response.data.error
        }]);
      }
    },

    onSelectList: function(e, data) {
      var self = $scope.pricingLists;
      console.log('PricingListsController::onSelectList', data);
      self.selectedPriceListId = data.id;
      self.currentPriceListIndex = self.getSelectedPriceList();
      self.currentPriceList = self.model[self.currentPriceListIndex];
      self.tmpCurrentPriceList = angular.copy(self.currentPriceList);

      self.currentPriceList = self.model[self.currentPriceListIndex];
    },

    onAddPrice: function(e, data) {
      var i, ii, self = $scope.pricingLists, r = false;

      self.notice.hideErrorMessages();
      console.log('PricingListsController::onAddPrice', data.price);

      for (i = 0, ii = self.currentPriceList.prices.length; i < ii; i++) {
        if(self.currentPriceList.prices[i].personType.id === data.price.personType.id) {
          self.notice.showErrorMessages( [{
            message: 'Ticket type '+ data.price.personType.name +' is already added. Please double click below to edit it.'
          }]);
          r = true;
          break;
        }
      }
      if (!r) {
        self.currentPriceList.prices.push(data.price);
      }
    },

    onGridEventChangeOrder: function(e, data) {
      var i, ii,
        self = $scope.pricingLists;

      if(data && data.from !== undefined && data.to !== undefined) {
        for (i=0,ii=self.currentPriceList.prices.length;i<ii;i++) {
          self.currentPriceList.prices[i].displayOrder = i + 1;
        }
      }
    }

  };

  $scope.pricingListsGrid = {
    enableRowSelection: false,
    showFooter: true,
    paginate: true,
    pageSize: 50,
    multiSelect: false,
    appScopeProvider: {
      pricingLists: $scope.pricingLists,
      removePrice: $scope.pricingLists.removePrice,
      onCellEdit: $scope.pricingLists.onDisplayOrderChanged,
      moveUp: $scope.pricingLists.moveUp,
      moveDown: $scope.pricingLists.moveDown
    }
  };

  $scope.pricingLists.init();

}])
.controller('PricingListsEditController', ['$scope', '$state', '$uibModal', '$timeout', 'HelpersService', 'ApiService', 'CalendarService', 'ValidateService', function($scope, $state, $uibModal, $timeout, HelpersService, ApiService, CalendarService, ValidateService) {


  $scope.pricingListsEdit = {

    editTitle: true,
    isCreated: false,
    isLoaded: false,
    isSubmitted: false,
    createPanelShown: false,

    selectedPrice: '',
    selectedDescription: '',
    selectedAdmissionCategory: {},
    currentAdmissionType: 'Individual',

    currentPriceIndex: 0,
    currentCategories: [],

    currentPrice: {
      personType: {
        name: '',
        description: '',
        active: true,
        type: 'Individual',
        defaultPrice: null
      },
      salesChannels: [],
      price: null,
      primePrice: null
    },

    model: {
      name: '',
      description: '',
      effectiveStartTime: CalendarService.toISO8601(new Date()),
      effectiveEndTime: null,
      prices: []
    },

    salesChannels: [
      {
        "channel" : "online",
        "name" : "Online",
        "enabled" : true
      },
      {
        "channel" : "pointOfSale",
        "name" : "Point of Sale",
        "enabled" : true
      },
      {
        "channel" : "reseller",
        "name" : "Reseller",
        "enabled" : true
      },
      {
        "channel" : "customerRep",
        "name" : "Customer Rep.",
        "enabled" : true
      },
      {
        "channel" : "kiosk",
        "name" : "Kiosk",
        "enabled" : false
      }
    ],

    categories: {
      individual: [],
      combo: []
    },

    init: function() {

      $scope.$watchCollection('pricingListsEdit.currentAdmissionType', this.onAdmissionTypeUpdate);
      $scope.$on('PriceLists::Update::selectList', this.onSelectList);

      this.getCurrentGroupCategories();
    },

    updatePrice: function() {
      if (this.selectedAdmissionCategory) {
        this.currentPrice.personType = this.selectedAdmissionCategory;
        this.selectedPrice = this.currentPrice.personType.defaultPrice;
        this.selectedDescription = this.currentPrice.personType.description;
      }else{
        this.selectedPrice = '';
        this.selectedDescription = '';
        this.selectedAdmissionCategory = '';
      }
    },

    hasPrices: function() {
      return (this.model.prices);
    },

    addPrice: function() {
      var self = $scope.pricingListsEdit;

      if (!(this.model.prices instanceof Array)) {
        this.model.prices = [];
      }
      console.log('PricingListsEditController::addPrice', this.currentPrice, this.selectedAdmissionCategory, this.currentAdmissionType);
      this.currentPrice.price = angular.copy(this.selectedPrice);
      this.currentPrice.personType = angular.copy(this.selectedAdmissionCategory);
      this.currentPrice.personType.type = angular.copy(this.currentAdmissionType);
      this.currentPrice.personType.description = angular.copy(this.selectedDescription);
      this.currentPrice.salesChannels = angular.copy(this.salesChannels);

      // kiosk must be disabled by default
      angular.forEach(this.currentPrice.salesChannels, function(item, index) {
        if (item.channel === 'kiosk') {
          self.currentPrice.salesChannels[index].enabled = false;
        }
      });

      if (this.isValidCurrentPrice()) {
        $scope.$emit('PricingListsEditController::addPrice', { price: angular.copy(this.currentPrice) });
        this.selectedAdmissionCategory = '';
        this.updatePrice();

      }
    },

    getCurrentGroupCategories: function() {
      var type = this.currentAdmissionType.toLowerCase(), props = HelpersService.getPaginator();

      props.types = (type === 'combo') ? 'combo' : 'normal';

      console.log('PricingListsController::getCurrentGroupCategories', type, this.categories[type]);
      if (this.categories[type].length === 0) {
        ApiService.price.types.list(props).then(this.success.getCurrentGroupCategories, this.error.getCurrentGroupCategories);
      }else{
        this.currentCategories = this.categories[type].slice(0);
        this.selectedAdmissionCategory = '';
        this.updatePrice();
      }
    },

    isValidCurrentPrice: function() {
      console.log('PricingListsEditController::isValidCurrentPrice', ValidateService.validate([{
        greater: {
          greater: this.currentPrice.price,
          less: -1
        }
      }]), this.currentPrice.price);
      return ValidateService.validate([{
        greater: {
          greater: this.currentPrice.price,
          less: -1
        }
      }]);
    },

    success: {

      addPrice: function(response) {
        console.log('PricingListsController::success::addPrice', response);
      },

      getCurrentGroupCategories: function(response) {
        var categoryType = '';

        if (response.data.payload.list.length > 0) {
          categoryType = response.data.payload.list[0].type;
          $scope.pricingListsEdit.categories[categoryType.toLowerCase()] = response.data.payload.list;
          $scope.pricingListsEdit.currentCategories = response.data.payload.list;
          $scope.pricingListsEdit.updatePrice();
        }
        $scope.pricingListsEdit.isLoaded = true;
        $scope.$emit('AppController::endLoad');

      }

    },

    error: {
      getCurrentGroupCategories: function(response) {
        //TODO: Need to handle this
      }
    },

    onAdmissionTypeUpdate: function(o, n) {
      if (n !== o) {
        console.log('PricingListsController::onAdmissionTypeUpdate');
        $scope.pricingListsEdit.getCurrentGroupCategories();
      }
    }

  };

  $scope.pricingListsEdit.init();

}]);